import { schemaGenerator } from "../utils";

export const calendarContainerCommon =
  "flex flex-col flex-nowrap py-[12px] px-[12px] w-[240px] min-h-[240px] select-none bg-white";
const calendarDayCommon =
  "justify-center cursor-pointer flex items-center rounded-[4px] font-['Open_Sans'] text-[14px]";
const monthSelectorCommon =
  "h-[32px] w-[40px] text-center border-0 bg-transparent rounded-[4px] justify-center items-center";

export const dateInputClassNames = (
  showTimePicker,
  showEndTimePicker,
  dateFormatError
) => {
  if (
    (showTimePicker && showEndTimePicker) ||
    (!showTimePicker && !showEndTimePicker)
  ) {
    return dateFormatError ? "w-full mb-[12px]" : "w-full";
  }

  return dateFormatError ? "w-[104px] mb-[12px]" : "w-[104px]";
};

const dictionary = {
  dayDisabled: {
    base: [calendarDayCommon],
    default: ["text-semantic-red-10 w-[31px] h-[28px]", "!cursor-default"],
  },
  daySelected: {
    base: [calendarDayCommon],
    default: ["bg-primary text-white w-[31px] h-[28px]"],
  },
  dayTempToday: {
    default: ["text-white"],
  },
  dayToday: {
    base: [calendarDayCommon],
    default: [
      "border-primary text-primary border-[1px] border-solid m-auto w-[24px] h-[20px] justify-center cursor-pointer flex items-center rounded-[4px]",
    ],
  },
  dayOutside: {
    base: [calendarDayCommon],
    default: ["text-placeholder w-[31px] h-[28px]"],
    hover: ["hover:bg-gray-300"],
  },
  dayDefault: {
    base: [calendarDayCommon],
    default: ["text-gray-primary w-[31px] h-[28px]"],
    hover: ["hover:bg-gray-300"],
  },
  monthSelected: {
    base: [monthSelectorCommon],
    default: ["text-gray-primary font-['Open_Sans'] font-bold"],
    hover: ["hover:bg-gray-300"],
    active: ["active:bg-gray-200"],
  },
  monthDefault: {
    base: [monthSelectorCommon],
    default: ["text-gray-primary"],
    hover: ["hover:bg-gray-300"],
    active: ["active:bg-gray-200"],
  },
  navigation: {
    base: [
      "font-bold  font-['Open_Sans'] flex border-0 bg-transparent rounded-[4px] items-center p-[4px]",
    ],
    default: ["text-gray-primary"],
    hover: ["hover:bg-gray-300"],
    active: ["active:bg-gray-200"],
    disabled: [
      "disabled:text-neutral-gray-30",
      "hover:bg-transparent",
      "active:bg-transparent",
    ],
  },
  navigationMode: {
    base: [
      "font-bold  font-['Open_Sans'] text-[14px] flex border-0 bg-transparent rounded-[4px] items-center py-[1px] pl-[6px] pr-[4px]",
    ],
    default: ["text-gray-primary"],
    hover: ["hover:bg-gray-300"],
    active: ["active:bg-gray-200"],
  },
  closeTimePicker: {
    default: [
      "text-gray-secondary flex p-[6px] border-0 bg-transparent rounded-[4px] items-center ml-auto",
    ],
    hover: ["hover:bg-gray-primary"],
  },
};

const schema = schemaGenerator(dictionary);

export default schema;
